// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Item-module__font-s-10___I_o4A {
  font-size: 10px !important;
}

.Item-module__font-s-12___QCoOM {
  font-size: 12px !important;
}

.Item-module__font-s-13___OoMSw {
  font-size: 13px !important;
}

.Item-module__font-s-14___rj3HI {
  font-size: 14px !important;
}

.Item-module__font-s-15___MY2iW {
  font-size: 15px !important;
}

.Item-module__font-s-16___hh8MD {
  font-size: 16px !important;
}

.Item-module__font-s-18___XvbFl {
  font-size: 18px !important;
}

.Item-module__font-s-20___lvITw {
  font-size: 20px !important;
}

.Item-module__font-s-22___nD6YW {
  font-size: 22px !important;
}

.Item-module__font-s-28___mCxKm {
  font-size: 28px !important;
}

.Item-module__font-w-400___PgtsC {
  font-weight: 400 !important;
}

.Item-module__font-w-500____io1d {
  font-weight: 500 !important;
}

.Item-module__font-w-600___U6fG7 {
  font-weight: 600 !important;
}

.Item-module__font-w-700___r8rli {
  font-weight: 700 !important;
}

.Item-module__p-5___yrJLA {
  padding: 5px !important;
}

.Item-module__p-12___QHy1i {
  padding: 12px !important;
}

.Item-module__p-16___pvs0N {
  padding: 16px !important;
}

.Item-module__p-30___ZJTbG {
  padding: 30px !important;
}

.Item-module__p-b-0___by0lp {
  padding-bottom: 0 !important;
}

.Item-module__p-b-5___pfVR2 {
  padding-bottom: 5px !important;
}

.Item-module__p-b-10___ecPDK {
  padding-bottom: 10px !important;
}

.Item-module__p-b-12___mCq1q {
  padding-bottom: 12px !important;
}

.Item-module__p-b-16___cYFuC {
  padding-bottom: 16px !important;
}

.Item-module__p-b-18___b4Gnm {
  padding-bottom: 18px !important;
}

.Item-module__p-b-20___qvJPE {
  padding-bottom: 20px !important;
}

.Item-module__p-b-25___cjH7B {
  padding-bottom: 25px !important;
}

.Item-module__p-b-30___KHbzl {
  padding-bottom: 30px !important;
}

.Item-module__p-b-50___DTwoo {
  padding-bottom: 50px !important;
}

.Item-module__p-t-0___Xs7gk {
  padding-top: 0 !important;
}

.Item-module__p-t-12___vBXei {
  padding-top: 12px !important;
}

.Item-module__p-t-16___Oe7mL {
  padding-top: 16px !important;
}

.Item-module__p-t-18___T_y9g {
  padding-top: 18px !important;
}

.Item-module__p-t-20___VHDwP {
  padding-top: 20px !important;
}

.Item-module__p-t-30___e1wqP {
  padding-top: 30px !important;
}

.Item-module__p-t-40___IhOvq {
  padding-top: 40px !important;
}

.Item-module__p-t-50___BpFZj {
  padding-top: 50px !important;
}

.Item-module__p-l-20___ne9xb {
  padding-left: 20px !important;
}

.Item-module__p-l-30___x3upZ {
  padding-left: 30px !important;
}

.Item-module__p-l-40___oJDN_ {
  padding-left: 40px !important;
}

.Item-module__p-r-16___cc5M_ {
  padding-right: 16px !important;
}

.Item-module__p-r-20___qFnkY {
  padding-right: 20px !important;
}

.Item-module__p-r-30___GqtwB {
  padding-right: 30px !important;
}

.Item-module__p-r-50___EYV0x {
  padding-right: 50px !important;
}

.Item-module__p-r-60___N5P4m {
  padding-right: 60px !important;
}

.Item-module__m-b-1___giVNe {
  margin-bottom: 1px !important;
}

.Item-module__m-b-2___yGBwh {
  margin-bottom: 2px !important;
}

.Item-module__m-b-6___mNE7Y {
  margin-bottom: 6px !important;
}

.Item-module__m-b-8___s9D3n {
  margin-bottom: 8px !important;
}

.Item-module__m-b-10___G3F9y {
  margin-bottom: 10px !important;
}

.Item-module__m-b-14___KxKbR {
  margin-bottom: 14px !important;
}

.Item-module__m-b-16___cJ5qb {
  margin-bottom: 16px !important;
}

.Item-module__m-b-20___eNlW7 {
  margin-bottom: 20px !important;
}

.Item-module__m-b-22___NAG5l {
  margin-bottom: 22px !important;
}

.Item-module__m-b-24___iyjLL {
  margin-bottom: 24px !important;
}

.Item-module__m-b-30___CIe7c {
  margin-bottom: 30px !important;
}

.Item-module__m-b-32___xOmBa {
  margin-bottom: 32px !important;
}

.Item-module__m-b-40___kijoK {
  margin-bottom: 40px !important;
}

.Item-module__m-t-2___k9dEh {
  margin-top: 2px !important;
}

.Item-module__m-t-3___yFCrR {
  margin-top: 3px !important;
}

.Item-module__m-t-4___Fms_q {
  margin-top: 4px !important;
}

.Item-module__m-t-5___zN74f {
  margin-top: 5px !important;
}

.Item-module__m-t-8___itxvy {
  margin-top: 8px !important;
}

.Item-module__m-t-10___nf6N7 {
  margin-top: 10px !important;
}

.Item-module__m-t-15___uf25v {
  margin-top: 15px !important;
}

.Item-module__m-t-16___fJfiq {
  margin-top: 16px !important;
}

.Item-module__m-t-20___oGp8F {
  margin-top: 20px !important;
}

.Item-module__m-t-22___dDypd {
  margin-top: 22px !important;
}

.Item-module__m-t-30___j7yMB {
  margin-top: 30px !important;
}

.Item-module__m-t-32___u1vbj {
  margin-top: 32px !important;
}

.Item-module__m-l-auto___uxJBR {
  margin-left: auto !important;
}

.Item-module__m-l-4___yXlrs {
  margin-left: 4px !important;
}

.Item-module__m-l-5___ED427 {
  margin-left: 5px !important;
}

.Item-module__m-l-6___rloht {
  margin-left: 6px !important;
}

.Item-module__m-l-8___pAVG_ {
  margin-left: 8px !important;
}

.Item-module__m-l-10___FSzUq {
  margin-left: 10px !important;
}

.Item-module__m-l-16___TlOpm {
  margin-left: 16px !important;
}

.Item-module__m-l-20___lJWIF {
  margin-left: 20px !important;
}

.Item-module__m-l-24___rtTaC {
  margin-left: 24px !important;
}

.Item-module__m-l-30___PvvXF {
  margin-left: 30px !important;
}

.Item-module__m-l-35___pgwYB {
  margin-left: 35px !important;
}

.Item-module__m-l-40___h8Z_i {
  margin-left: 40px !important;
}

.Item-module__m-r-8___XsVwH {
  margin-right: 8px !important;
}

.Item-module__m-r-10___UC4BR {
  margin-right: 10px !important;
}

.Item-module__m-r-16___tP45B {
  margin-right: 16px !important;
}

.Item-module__m-r-20___zpe1L {
  margin-right: 20px !important;
}

.Item-module__m-r-24___PBi_Z {
  margin-right: 24px !important;
}

.Item-module__m-r-30___dIQKt {
  margin-right: 30px !important;
}

.Item-module__m-r-40___Dp97H {
  margin-right: 40px !important;
}

.Item-module__border-r-3___lE8YO {
  border-radius: 3px !important;
}

.Item-module__border-r-4___jnphc {
  border-radius: 4px !important;
}

.Item-module__border-r-6___VRsiV {
  border-radius: 6px !important;
}

.Item-module__border-r-10___ReLrV {
  border-radius: 10px !important;
}

.Item-module__border-r-12___D7bit {
  border-radius: 12px !important;
}

.Item-module__border-r-16___iUHiX {
  border-radius: 16px !important;
}

.Item-module__border-r-50___DEaNQ {
  border-radius: 50% !important;
}

.Item-module__primary-border___XHWyA {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-b___S8Ckw {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-t___tBslz {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-l___KZRSM {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__primary-border-r___Jo9Jc {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Item-module__secondary-border___EQhYX {
  border: 1px solid #637768;
}

.Item-module__secondary-border-b___hhzhQ {
  border-bottom: 1px solid #637768;
}

.Item-module__secondary-border-t___uBrno {
  border-top: 1px solid #637768;
}

.Item-module__secondary-border-l___DeKXQ {
  border-left: 1px solid #637768;
}

.Item-module__secondary-border-r___yiUT8 {
  border-right: 1px solid #637768;
}

.Item-module__gap-0___ThmjV {
  gap: 0 !important;
}

.Item-module__gap-2___qC0AM {
  gap: 2px !important;
}

.Item-module__gap-4___Lsvd4 {
  gap: 4px !important;
}

.Item-module__gap-5___q0x0n {
  gap: 5px !important;
}

.Item-module__gap-6___M3U5M {
  gap: 6px !important;
}

.Item-module__gap-8___zn9TL {
  gap: 8px !important;
}

.Item-module__gap-10___zoI0f {
  gap: 10px !important;
}

.Item-module__gap-12___TqKcl {
  gap: 12px !important;
}

.Item-module__gap-14___e1paG {
  gap: 14px !important;
}

.Item-module__gap-16___Uy4BA {
  gap: 16px !important;
}

.Item-module__gap-18___l6tLD {
  gap: 18px !important;
}

.Item-module__gap-20____tHX6 {
  gap: 20px !important;
}

.Item-module__gap-24___gUsIw {
  gap: 24px !important;
}

.Item-module__gap-26___i1Knf {
  gap: 26px !important;
}

.Item-module__gap-30___G8ioN {
  gap: 30px !important;
}

.Item-module__gap-32___VhMRR {
  gap: 32px !important;
}

.Item-module__gap-40___YmKRB {
  gap: 40px !important;
}

.Item-module__gap-50___lVbqc {
  gap: 50px !important;
}

.Item-module__flex-1___KSM82 {
  flex: 1;
}

.Item-module__flex-none___ysf2I {
  flex: none !important;
}

.Item-module__flex-column___tJef6 {
  display: flex;
  flex-direction: column !important;
}

.Item-module__flex-row___CLsIw {
  display: flex;
  flex-direction: row !important;
}

.Item-module__vertically-centered___ClpCY {
  display: flex;
  align-items: center !important;
}

.Item-module__horizontally-centered___Shid8 {
  display: flex;
  justify-content: center !important;
}

.Item-module__horizontally-end___w17Fy {
  display: flex;
  justify-content: end !important;
}

.Item-module__vertically-start___g0VAx {
  display: flex;
  align-items: start !important;
}

.Item-module__space-between___pL1Mf {
  display: flex;
  justify-content: space-between !important;
}

.Item-module__flex-wrap____Bbuj {
  flex-wrap: wrap !important;
}

.Item-module__height-100___c6RZv {
  height: 100%;
}

.Item-module__width-50___qWvRM {
  width: 50% !important;
}

.Item-module__width-100___aRoFY {
  width: 100%;
}

.Item-module__cursor-pointer___ChMcr {
  cursor: pointer;
}

.Item-module__cursor-not-allowed___Kbqqq {
  cursor: not-allowed !important;
}

.Item-module__absolute-centered___v8oFT {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Item-module__absolute___nyJfq {
  position: absolute;
}

.Item-module__relative___z3JPg {
  position: relative;
}

.Item-module__fixed___Gbgzn {
  position: fixed;
}

.Item-module__visible___C_MPh {
  opacity: 1;
}

.Item-module__invisible___JxSm1 {
  opacity: 0;
}

.Item-module__col-90___t8aLa {
  width: 90% !important;
}

.Item-module__col-auto___R4Aa3 {
  width: auto !important;
}

.Item-module__medical-tabs___prcJh {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Item-module__medical-table-new___Hxk5S {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Item-module__medical-table-new___Hxk5S:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Item-module__medical-table-new___Hxk5S::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Item-module__medical-table-new___Hxk5S::-webkit-scrollbar-track {
  display: none;
}
.Item-module__medical-table-new___Hxk5S.Item-module__no-pagination___wL1VB {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Item-module__medical-table-new___Hxk5S.Item-module__no-pagination___wL1VB:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Item-module__medical-table-new___Hxk5S.Item-module__no-pagination___wL1VB::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Item-module__medical-table-new___Hxk5S.Item-module__no-pagination___wL1VB::-webkit-scrollbar-track {
  display: none;
}

.Item-module__medical-table-empty___wlB0l {
  padding: 14px 40px !important;
}

.Item-module__icon-btn___Kgvcn {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Item-module__search-icon___yAt6C {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Item-module__disable-select___zIAO9 {
  user-select: none;
}

.Item-module__break-word___F4XtI {
  word-break: break-word;
}

.Item-module__popup-clear-btn___c5Tm1 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Item-module__scroll-m-b-20___wyL4U {
  scroll-margin-bottom: 20px;
}

.Item-module__container___Qea52 {
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  border-radius: 12px;
  margin: 8px 35px 35px 35px;
}
.Item-module__container___Qea52 .Item-module__icon___quVeD {
  width: 34px;
  height: 34px;
}
.Item-module__container___Qea52 .Item-module__textContainer____ZXyw {
  width: 33%;
}
.Item-module__container___Qea52 .Item-module__textContainer____ZXyw .Item-module__orderedBy___RAqAd {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 150%;
  color: #a79988;
}
.Item-module__container___Qea52 .Item-module__textContainer____ZXyw .Item-module__product___tQDGv {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 19px;
  color: #375844;
}
.Item-module__container___Qea52 .Item-module__textContainer____ZXyw .Item-module__orderedAt___voWUZ {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 15px;
  color: #637768;
}
.Item-module__container___Qea52 .Item-module__notes___to95Y {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 15px;
  color: #637768;
}
.Item-module__container___Qea52 .Item-module__supplierContainer___YM1Dn {
  width: 33%;
}
.Item-module__container___Qea52 .Item-module__supplierContainer___YM1Dn .Item-module__supplierLabel___TgCvR {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 15px;
  color: #637768;
}
.Item-module__container___Qea52 .Item-module__supplierContainer___YM1Dn .Item-module__supplier___Rcx72 {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 27px;
  color: #375844;
}
.Item-module__container___Qea52 .Item-module__dateLabel___EI_tr {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 15px;
  color: #637768;
}
.Item-module__container___Qea52 .Item-module__date___C8DqZ {
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 150%;
  color: #375844;
}
.Item-module__container___Qea52 .Item-module__status___NBmxM {
  align-self: center;
  padding: 6px 8px;
  border-radius: 33px;
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 17px;
  color: #375844;
  cursor: pointer;
}
.Item-module__container___Qea52 .Item-module__viewOrderButton___telig {
  height: 34px;
  min-width: 130px;
  border: 1.5px solid #375844;
  border-radius: 6px;
  padding: 10px;
  transition: background-color 0.4s ease;
}
.Item-module__container___Qea52 .Item-module__viewOrderButton___telig:hover {
  background-color: #f1f6f2;
}
.Item-module__container___Qea52 .Item-module__viewOrderButton___telig .Item-module__icon___quVeD {
  width: 20px;
  height: 20px;
}
.Item-module__container___Qea52 .Item-module__viewOrderButton___telig .Item-module__text___xPxp3 {
  font-family: var(--font-family);
  font-weight: 400;
  font-style: normal;
  line-height: 150%;
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/fragments/CGMOrdersFragment/components/OrderHistoryList/Item/Item.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,0BAAA;AA8pBF;AA5pBE;EACE,WAAA;EACA,YAAA;AA8pBJ;AA3pBE;EACE,UAAA;AA6pBJ;AA3pBI;EESF,+BApBO;EAqBP,gBAFmD;EFN/C,iBAAA;EACA,cAAA;AA8pBN;AA3pBI;EEGF,+BApBO;EAqBP,gBAFmD;EFA/C,iBAAA;EACA,cAAA;AA8pBN;AA3pBI;EEHF,+BApBO;EAqBP,gBAFmD;EFM/C,iBAAA;EACA,cAAA;AA8pBN;AA1pBE;EEVA,+BApBO;EAqBP,gBAFmD;EFajD,iBAAA;EACA,cAAA;AA6pBJ;AA1pBE;EACE,UAAA;AA4pBJ;AA1pBI;EEnBF,+BApBO;EAqBP,gBAFmD;EFsB/C,iBAAA;EACA,cAAA;AA6pBN;AA1pBI;EEzBF,+BApBO;EAqBP,gBAFmD;EF4B/C,iBAAA;EACA,cAAA;AA6pBN;AAzpBE;EEhCA,+BApBO;EAqBP,gBAFmD;EFmCjD,iBAAA;EACA,cAAA;AA4pBJ;AAzpBE;EEtCA,+BApBO;EAqBP,gBAFmD;EFyCjD,iBAAA;EACA,cAAA;AA4pBJ;AAzpBE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EE/CF,+BApBO;EAqBP,gBAFmD;EFkDjD,iBAAA;EACA,cAAA;EACA,eAAA;AA4pBJ;AAzpBE;EACE,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,aAAA;EACA,sCAAA;AA2pBJ;AAzpBI;EACE,yBAAA;AA2pBN;AAxpBI;EACE,WAAA;EACA,YAAA;AA0pBN;AAvpBI;EEvEF,+BApBO;EAqBP,gBAFmD;EF0E/C,kBAAA;EACA,iBAAA;EACA,cAAA;AA0pBN","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  display: flex;\n  flex-direction: column;\n  padding: 12px 0;\n  border-radius: 12px;\n  margin: 8px 35px 35px 35px;\n\n  .icon {\n    width: 34px;\n    height: 34px;\n  }\n\n  .textContainer {\n    width: 33%;\n\n    .orderedBy {\n      @include get-font($roboto);\n      line-height: 150%;\n      color: #a79988;\n    }\n\n    .product {\n      @include get-font($roboto);\n      line-height: 19px;\n      color: get-color(greenNew, dark);\n    }\n\n    .orderedAt {\n      @include get-font($roboto);\n      line-height: 15px;\n      color: get-color(greenNew, medium-dark);\n    }\n  }\n\n  .notes {\n    @include get-font($roboto);\n    line-height: 15px;\n    color: get-color(greenNew, medium-dark);\n  }\n\n  .supplierContainer {\n    width: 33%;\n\n    .supplierLabel {\n      @include get-font($roboto);\n      line-height: 15px;\n      color: get-color(greenNew, medium-dark);\n    }\n\n    .supplier {\n      @include get-font($roboto);\n      line-height: 27px;\n      color: get-color(greenNew, dark);\n    }\n  }\n\n  .dateLabel {\n    @include get-font($roboto);\n    line-height: 15px;\n    color: get-color(greenNew, medium-dark);\n  }\n\n  .date {\n    @include get-font($roboto);\n    line-height: 150%;\n    color: get-color(greenNew, dark);\n  }\n\n  .status {\n    align-self: center;\n    padding: 6px 8px;\n    border-radius: 33px;\n    @include get-font($roboto);\n    line-height: 17px;\n    color: get-color(greenNew, dark);\n    cursor: pointer;\n  }\n\n  .viewOrderButton {\n    height: 34px;\n    min-width: 130px;\n    border: 1.5px solid #375844;\n    border-radius: 6px;\n    padding: 10px;\n    transition: background-color 0.4s ease;\n\n    &:hover {\n      background-color: get-color(greenNew, ultra-light);\n    }\n\n    .icon {\n      width: 20px;\n      height: 20px;\n    }\n\n    .text {\n      @include get-font($roboto);\n      font-style: normal;\n      line-height: 150%;\n      color: get-color(greenNew, dark);\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Item-module__font-s-10___I_o4A`,
	"fontS12": `Item-module__font-s-12___QCoOM`,
	"fontS13": `Item-module__font-s-13___OoMSw`,
	"fontS14": `Item-module__font-s-14___rj3HI`,
	"fontS15": `Item-module__font-s-15___MY2iW`,
	"fontS16": `Item-module__font-s-16___hh8MD`,
	"fontS18": `Item-module__font-s-18___XvbFl`,
	"fontS20": `Item-module__font-s-20___lvITw`,
	"fontS22": `Item-module__font-s-22___nD6YW`,
	"fontS28": `Item-module__font-s-28___mCxKm`,
	"fontW400": `Item-module__font-w-400___PgtsC`,
	"fontW500": `Item-module__font-w-500____io1d`,
	"fontW600": `Item-module__font-w-600___U6fG7`,
	"fontW700": `Item-module__font-w-700___r8rli`,
	"p5": `Item-module__p-5___yrJLA`,
	"p12": `Item-module__p-12___QHy1i`,
	"p16": `Item-module__p-16___pvs0N`,
	"p30": `Item-module__p-30___ZJTbG`,
	"pB0": `Item-module__p-b-0___by0lp`,
	"pB5": `Item-module__p-b-5___pfVR2`,
	"pB10": `Item-module__p-b-10___ecPDK`,
	"pB12": `Item-module__p-b-12___mCq1q`,
	"pB16": `Item-module__p-b-16___cYFuC`,
	"pB18": `Item-module__p-b-18___b4Gnm`,
	"pB20": `Item-module__p-b-20___qvJPE`,
	"pB25": `Item-module__p-b-25___cjH7B`,
	"pB30": `Item-module__p-b-30___KHbzl`,
	"pB50": `Item-module__p-b-50___DTwoo`,
	"pT0": `Item-module__p-t-0___Xs7gk`,
	"pT12": `Item-module__p-t-12___vBXei`,
	"pT16": `Item-module__p-t-16___Oe7mL`,
	"pT18": `Item-module__p-t-18___T_y9g`,
	"pT20": `Item-module__p-t-20___VHDwP`,
	"pT30": `Item-module__p-t-30___e1wqP`,
	"pT40": `Item-module__p-t-40___IhOvq`,
	"pT50": `Item-module__p-t-50___BpFZj`,
	"pL20": `Item-module__p-l-20___ne9xb`,
	"pL30": `Item-module__p-l-30___x3upZ`,
	"pL40": `Item-module__p-l-40___oJDN_`,
	"pR16": `Item-module__p-r-16___cc5M_`,
	"pR20": `Item-module__p-r-20___qFnkY`,
	"pR30": `Item-module__p-r-30___GqtwB`,
	"pR50": `Item-module__p-r-50___EYV0x`,
	"pR60": `Item-module__p-r-60___N5P4m`,
	"mB1": `Item-module__m-b-1___giVNe`,
	"mB2": `Item-module__m-b-2___yGBwh`,
	"mB6": `Item-module__m-b-6___mNE7Y`,
	"mB8": `Item-module__m-b-8___s9D3n`,
	"mB10": `Item-module__m-b-10___G3F9y`,
	"mB14": `Item-module__m-b-14___KxKbR`,
	"mB16": `Item-module__m-b-16___cJ5qb`,
	"mB20": `Item-module__m-b-20___eNlW7`,
	"mB22": `Item-module__m-b-22___NAG5l`,
	"mB24": `Item-module__m-b-24___iyjLL`,
	"mB30": `Item-module__m-b-30___CIe7c`,
	"mB32": `Item-module__m-b-32___xOmBa`,
	"mB40": `Item-module__m-b-40___kijoK`,
	"mT2": `Item-module__m-t-2___k9dEh`,
	"mT3": `Item-module__m-t-3___yFCrR`,
	"mT4": `Item-module__m-t-4___Fms_q`,
	"mT5": `Item-module__m-t-5___zN74f`,
	"mT8": `Item-module__m-t-8___itxvy`,
	"mT10": `Item-module__m-t-10___nf6N7`,
	"mT15": `Item-module__m-t-15___uf25v`,
	"mT16": `Item-module__m-t-16___fJfiq`,
	"mT20": `Item-module__m-t-20___oGp8F`,
	"mT22": `Item-module__m-t-22___dDypd`,
	"mT30": `Item-module__m-t-30___j7yMB`,
	"mT32": `Item-module__m-t-32___u1vbj`,
	"mLAuto": `Item-module__m-l-auto___uxJBR`,
	"mL4": `Item-module__m-l-4___yXlrs`,
	"mL5": `Item-module__m-l-5___ED427`,
	"mL6": `Item-module__m-l-6___rloht`,
	"mL8": `Item-module__m-l-8___pAVG_`,
	"mL10": `Item-module__m-l-10___FSzUq`,
	"mL16": `Item-module__m-l-16___TlOpm`,
	"mL20": `Item-module__m-l-20___lJWIF`,
	"mL24": `Item-module__m-l-24___rtTaC`,
	"mL30": `Item-module__m-l-30___PvvXF`,
	"mL35": `Item-module__m-l-35___pgwYB`,
	"mL40": `Item-module__m-l-40___h8Z_i`,
	"mR8": `Item-module__m-r-8___XsVwH`,
	"mR10": `Item-module__m-r-10___UC4BR`,
	"mR16": `Item-module__m-r-16___tP45B`,
	"mR20": `Item-module__m-r-20___zpe1L`,
	"mR24": `Item-module__m-r-24___PBi_Z`,
	"mR30": `Item-module__m-r-30___dIQKt`,
	"mR40": `Item-module__m-r-40___Dp97H`,
	"borderR3": `Item-module__border-r-3___lE8YO`,
	"borderR4": `Item-module__border-r-4___jnphc`,
	"borderR6": `Item-module__border-r-6___VRsiV`,
	"borderR10": `Item-module__border-r-10___ReLrV`,
	"borderR12": `Item-module__border-r-12___D7bit`,
	"borderR16": `Item-module__border-r-16___iUHiX`,
	"borderR50": `Item-module__border-r-50___DEaNQ`,
	"primaryBorder": `Item-module__primary-border___XHWyA`,
	"primaryBorderB": `Item-module__primary-border-b___S8Ckw`,
	"primaryBorderT": `Item-module__primary-border-t___tBslz`,
	"primaryBorderL": `Item-module__primary-border-l___KZRSM`,
	"primaryBorderR": `Item-module__primary-border-r___Jo9Jc`,
	"secondaryBorder": `Item-module__secondary-border___EQhYX`,
	"secondaryBorderB": `Item-module__secondary-border-b___hhzhQ`,
	"secondaryBorderT": `Item-module__secondary-border-t___uBrno`,
	"secondaryBorderL": `Item-module__secondary-border-l___DeKXQ`,
	"secondaryBorderR": `Item-module__secondary-border-r___yiUT8`,
	"gap0": `Item-module__gap-0___ThmjV`,
	"gap2": `Item-module__gap-2___qC0AM`,
	"gap4": `Item-module__gap-4___Lsvd4`,
	"gap5": `Item-module__gap-5___q0x0n`,
	"gap6": `Item-module__gap-6___M3U5M`,
	"gap8": `Item-module__gap-8___zn9TL`,
	"gap10": `Item-module__gap-10___zoI0f`,
	"gap12": `Item-module__gap-12___TqKcl`,
	"gap14": `Item-module__gap-14___e1paG`,
	"gap16": `Item-module__gap-16___Uy4BA`,
	"gap18": `Item-module__gap-18___l6tLD`,
	"gap20": `Item-module__gap-20____tHX6`,
	"gap24": `Item-module__gap-24___gUsIw`,
	"gap26": `Item-module__gap-26___i1Knf`,
	"gap30": `Item-module__gap-30___G8ioN`,
	"gap32": `Item-module__gap-32___VhMRR`,
	"gap40": `Item-module__gap-40___YmKRB`,
	"gap50": `Item-module__gap-50___lVbqc`,
	"flex1": `Item-module__flex-1___KSM82`,
	"flexNone": `Item-module__flex-none___ysf2I`,
	"flexColumn": `Item-module__flex-column___tJef6`,
	"flexRow": `Item-module__flex-row___CLsIw`,
	"verticallyCentered": `Item-module__vertically-centered___ClpCY`,
	"horizontallyCentered": `Item-module__horizontally-centered___Shid8`,
	"horizontallyEnd": `Item-module__horizontally-end___w17Fy`,
	"verticallyStart": `Item-module__vertically-start___g0VAx`,
	"spaceBetween": `Item-module__space-between___pL1Mf`,
	"flexWrap": `Item-module__flex-wrap____Bbuj`,
	"height100": `Item-module__height-100___c6RZv`,
	"width50": `Item-module__width-50___qWvRM`,
	"width100": `Item-module__width-100___aRoFY`,
	"cursorPointer": `Item-module__cursor-pointer___ChMcr`,
	"cursorNotAllowed": `Item-module__cursor-not-allowed___Kbqqq`,
	"absoluteCentered": `Item-module__absolute-centered___v8oFT`,
	"absolute": `Item-module__absolute___nyJfq`,
	"relative": `Item-module__relative___z3JPg`,
	"fixed": `Item-module__fixed___Gbgzn`,
	"visible": `Item-module__visible___C_MPh`,
	"invisible": `Item-module__invisible___JxSm1`,
	"col90": `Item-module__col-90___t8aLa`,
	"colAuto": `Item-module__col-auto___R4Aa3`,
	"medicalTabs": `Item-module__medical-tabs___prcJh`,
	"medicalTableNew": `Item-module__medical-table-new___Hxk5S`,
	"noPagination": `Item-module__no-pagination___wL1VB`,
	"medicalTableEmpty": `Item-module__medical-table-empty___wlB0l`,
	"iconBtn": `Item-module__icon-btn___Kgvcn`,
	"searchIcon": `Item-module__search-icon___yAt6C`,
	"disableSelect": `Item-module__disable-select___zIAO9`,
	"breakWord": `Item-module__break-word___F4XtI`,
	"popupClearBtn": `Item-module__popup-clear-btn___c5Tm1`,
	"scrollMB20": `Item-module__scroll-m-b-20___wyL4U`,
	"container": `Item-module__container___Qea52`,
	"icon": `Item-module__icon___quVeD`,
	"textContainer": `Item-module__textContainer____ZXyw`,
	"orderedBy": `Item-module__orderedBy___RAqAd`,
	"product": `Item-module__product___tQDGv`,
	"orderedAt": `Item-module__orderedAt___voWUZ`,
	"notes": `Item-module__notes___to95Y`,
	"supplierContainer": `Item-module__supplierContainer___YM1Dn`,
	"supplierLabel": `Item-module__supplierLabel___TgCvR`,
	"supplier": `Item-module__supplier___Rcx72`,
	"dateLabel": `Item-module__dateLabel___EI_tr`,
	"date": `Item-module__date___C8DqZ`,
	"status": `Item-module__status___NBmxM`,
	"viewOrderButton": `Item-module__viewOrderButton___telig`,
	"text": `Item-module__text___xPxp3`
};
module.exports = ___CSS_LOADER_EXPORT___;
